export default {
    url: 'ecoflow-power-kits/series',
    include: ['us', 'jp', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'za', 'kr', 'eu', 'sa'],
};
